import React from "react";
import _ from "lodash";
import classNames from "classnames";

import {
  SearchInput,
  ChecklistDropdown,
  FilterLabelButton,
} from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";
import { getLabelValueForMultiFilterLabelButton } from "Utils";

import classes from "./LearningCourseSelectionHeader.scss";

const LearningCourseSelectionHeader = ({
  courseSearchText,
  handleClassSearch,
  isCoursesLoading,
  grades,
  subjects,
  academicYearList,
  courseTypes,
  setAcademicYear,
  setCourseType,
  setGrade,
  setSubject,
  academicYear,
  courseType,
  grade,
  subject,
  isCurriculumPYP,
  totalCount,
}) => {
  const { t } = useI18n();

  return (
    <div className={classes.header}>
      <div className={classes.searchInputContainer}>
        <div className={classes.searchInput}>
          <SearchInput
            value={courseSearchText}
            onChange={handleClassSearch}
            placeholder={t("common:search")}
            testId={`courseFlow-importFromAnotherCourseModal-course`}
            focusSearchBySlash={true}
          />
        </div>
        {!isCoursesLoading ? (
          <div className={classNames("heading-6", classes.classCount)}>
            {t("course:courses_count", { count: totalCount })}
          </div>
        ) : null}
      </div>
      <div className={classes.filterContainer}>
        <ChecklistDropdown
          options={courseTypes}
          value={courseType}
          testId={`courseFlow-importFromAnotherCourseModal-courseType`}
          onChange={setCourseType}
          showAllOption={true}
        >
          <FilterLabelButton
            variant="neutral"
            type="plain"
            label={t("course:course_type_plural")}
            testId={`courseFlow-importFromAnotherCourseModal-courseType`}
            labelValue={getLabelValueForMultiFilterLabelButton({
              options: courseTypes,
              selectedOptions: courseType,
              t,
              noneText: t("common:select"),
              allText: t("common:all"),
            })}
          />
        </ChecklistDropdown>
        <ChecklistDropdown
          options={grades}
          value={grade}
          onChange={setGrade}
          testId={`courseFlow-importFromAnotherCourseModal-grade`}
          showAllOption={true}
        >
          <FilterLabelButton
            variant="neutral"
            type="plain"
            label={t("common:grades")}
            testId={`courseFlow-importFromAnotherCourseModal-grade`}
            labelValue={getLabelValueForMultiFilterLabelButton({
              options: grades,
              selectedOptions: grade,
              t,
              noneText: t("common:select"),
              allText: t("common:all"),
            })}
          />
        </ChecklistDropdown>
        {!isCurriculumPYP ? (
          <ChecklistDropdown
            options={subjects}
            value={subject}
            testId={`courseFlow-importFromAnotherCourseModal-subject`}
            onChange={setSubject}
            showAllOption={true}
          >
            <FilterLabelButton
              variant="neutral"
              type="plain"
              label={t("common:subject_plural")}
              testId={`courseFlow-importFromAnotherCourseModal-subject`}
              labelValue={getLabelValueForMultiFilterLabelButton({
                options: subjects,
                selectedOptions: subject,
                t,
                noneText: t("common:select"),
                allText: t("common:all"),
              })}
            />
          </ChecklistDropdown>
        ) : null}
        <ChecklistDropdown
          options={academicYearList}
          value={academicYear}
          testId={`courseFlow-importFromAnotherCourseModal-academicYear`}
          onChange={setAcademicYear}
          showAllOption={true}
        >
          <FilterLabelButton
            variant="neutral"
            type="plain"
            label={t("common:academic_year_plural")}
            testId={`courseFlow-importFromAnotherCourseModal-academicYear`}
            labelValue={
              _.size(academicYear) == 1
                ? _.get(
                    _.find(academicYearList, { value: _.first(academicYear) }),
                    "label"
                  )
                : getLabelValueForMultiFilterLabelButton({
                    options: academicYearList,
                    selectedOptions: academicYear,
                    t,
                    noneText: t("common:select"),
                    allText: t("common:all"),
                  })
            }
          />
        </ChecklistDropdown>
      </div>
    </div>
  );
};

export default LearningCourseSelectionHeader;
